<template>
  <div class="folios-page bgazul">
    <main class="container pb-5">
      <h1 class="text-center azul fanta mb-4">Folios de participación</h1>
      <div class="folios-panel">
        <label for="buscar-folio" class="font-weight-bold">Buscar folio</label>
        <input
          id="buscar-folio"
          v-model="busqueda"
          type="search"
          class="form-control mb-3"
          placeholder="Folio de participación o folio asignado para el sorteo"
          aria-controls="tabla-folios"
        />
        <p role="status">{{ filtrados.length }} registros</p>
        <div class="table-responsive">
          <table id="tabla-folios" class="table table-striped table-bordered text-center">
            <caption class="sr-only">Folios de participación y folios asignados para el sorteo</caption>
            <thead>
              <tr>
                <th v-for="encabezado in encabezados" :key="encabezado" scope="col">{{ encabezado }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(fila, indice) in paginaActual" :key="(pagina - 1) * porPagina + indice">
                <td>{{ fila[0] }}</td>
                <td>{{ fila[1] }}</td>
              </tr>
              <tr v-if="!filtrados.length">
                <td colspan="2">No se encontraron folios.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-pagination
          v-if="filtrados.length > porPagina"
          v-model="pagina"
          :total-rows="filtrados.length"
          :per-page="porPagina"
          aria-controls="tabla-folios"
          aria-label="Páginas de folios"
          label-first-page="Primera página"
          label-prev-page="Página anterior"
          label-next-page="Página siguiente"
          label-last-page="Última página"
          align="center"
        />
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import folios from "@/data/folios-participacion.json";

export default {
  components: { Footer },
  data() {
    return {
      encabezados: folios.headers,
      filas: Object.freeze(folios.rows),
      busqueda: "",
      pagina: 1,
      porPagina: 100,
    };
  },
  computed: {
    filtrados() {
      const consulta = this.busqueda.trim().toUpperCase();
      return consulta
        ? this.filas.filter(fila => fila.some(valor => valor.toUpperCase().includes(consulta)))
        : this.filas;
    },
    paginaActual() {
      const inicio = (this.pagina - 1) * this.porPagina;
      return this.filtrados.slice(inicio, inicio + this.porPagina);
    },
  },
  watch: {
    busqueda() {
      this.pagina = 1;
    },
  },
};
</script>

<style scoped>
.folios-page {
  min-height: 100vh;
  padding-top: 160px;
}
.folios-panel {
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  color: #163b65;
}
.folios-panel label[for="buscar-folio"],
#buscar-folio {
  color: #163b65;
  background-color: #fff;
}
#buscar-folio::placeholder {
  color: #163b65;
  opacity: 1;
}
th {
  vertical-align: middle !important;
}
td {
  white-space: pre-wrap;
}
@media (max-width: 575px) {
  .folios-panel { padding: 16px 10px; }
  th { font-size: 12px; }
}
</style>
